module.exports = __webpack_public_path__ + "img/casa.b2d3c123.png";